import {
  ExtendSuscriptionBtnIcon,
  MobileIcon,
  StudioPlatformIcon,
  SubscriptionStatusTag,
  WebPlatformIcon,
} from "icons";
import { SubscriptionCard } from "../subscriptionCard";
import styles from "./styles.module.scss";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { ConditionalRenderer } from "components";
import { useState } from "react";
import { ExtendSubscription } from "pages/analyticsV2/components/userDetailModal/components";
import { SubscriptionDetail } from "../subscriptionDetail";
import { Button, Popover } from "antd";
import moment from "moment";

export const CurrentSubscription = ({
  userID,
  totalRevenue,
  currentSubscription,
  currentPlanObj,
  currentSubscriptionRefetch,
}) => {
  const { isPlanExpired } = currentPlanObj || {};

  const [openExtendPopUp, setOpenExtendPopUp] = useState(false);
  function closeExtendPopUp() {
    setOpenExtendPopUp(false);
  }

  const listOfSubscriptionType = [
    {
      title: currentPlanObj.subscriptionName,
      bgColor: "#AACFFB",
    },
  ];
  const listOfPlatforms = [
    {
      title: "Studio",
      bgColor: "#FFFAED",
      icon: StudioPlatformIcon,
    },
    {
      title: "Web",
      bgColor: "#E7FFC5",
      icon: WebPlatformIcon,
    },
    {
      title: "Mobile",
      bgColor: "#EDFDFF",
      icon: MobileIcon,
    },
  ];
  const listOfDuration = [
    // {
    //   title: "3 Months",
    //   bgColor: "#AACFFB",
    // },
    // {
    //   title: "6 Months",
    //   bgColor: "#FFE7A5",
    // },
    {
      title: currentPlanObj.months,
      bgColor: "#C3F9E1",
    },
  ];

  return (
    <>
      <div className={styles.currentSubscription}>
        <div className={styles.extendHeading}>
          <div className={styles.heading}>Current Subscription</div>
          <div className={styles.extend}>
            <Button
              onClick={() => setOpenExtendPopUp(true)}
              className={styles.extendBtn}
            >
              <ExtendSuscriptionBtnIcon />
              Manage Subscription
            </Button>
          </div>
        </div>

        <div className={styles.cards}>
          <div style={{ position: "relative" }}>
            <SubscriptionCard
              title="Subscription Type"
              list={listOfSubscriptionType}
              cardBg="#E6F1FD"
            />
            <div
              className={`${styles.statusTag} ${
                isPlanExpired && styles.expiredStatusTag
              }`}
            >
              <SubscriptionStatusTag />
            </div>
            <div className={styles.tags}>
              <div className={styles.statusText}>
                {isPlanExpired ? "Expired" : "Active"}
              </div>
              <div className={styles.expiryDate}>
                {moment(currentPlanObj?.expiry).format("DD.MM.YYYY")}
              </div>
            </div>
          </div>
          <SubscriptionCard
            title="Platforms"
            list={currentPlanObj?.platforms}
            cardBg="#EDEEFC"
          />
          <SubscriptionCard
            title="Duration"
            list={listOfDuration}
            cardBg="#E6F1FD"
          />
          <SubscriptionCard
            title="Total Revenue"
            list={[]}
            cardBg="#EDEEFC"
            revenueAmount={totalRevenue}
          />
        </div>
      </div>
      <ConditionalRenderer condition={openExtendPopUp}>
        <SubscriptionDetail
          closeExtendPopUp={closeExtendPopUp}
          currentPlanObj={currentPlanObj}
          currentSubscription={currentSubscription}
          openExtendPopUp={openExtendPopUp}
          userID={userID}
          currentSubscriptionRefetch={currentSubscriptionRefetch}
        />
      </ConditionalRenderer>
    </>
  );
};
